module.exports = __webpack_public_path__ + "static/media/Lynne McTaggart copie.bec99ef5.jpg";